export default __webpack_public_path__ + "static/media/effect-4.6716ebd7.mp3";